/**
 * Typesafe Object.keys()
 */
export const getObjectKeys = <T extends Record<string, any>>(obj: T) =>
  Object.keys(obj) as (keyof T)[];
